import { Widget, getWidgetProps, WPSClient, StorefrontOutput, withArgs, safeBool } from 'DVWebNodeUtils'
import StorefrontComponent, { FeatureSwitches } from './shared/containers/Storefront';

const getProps: getWidgetProps<StorefrontOutput> = global.__SERVER__ || global.__NATIVEAPP__
  ? async ({ context, contentType, contentId, filters, isElcano, node, targetId,
    startIndex, pageNumber, pageSize, serviceToken, clientFilter
  }, api) => {

    const parsedPageNumber = pageNumber && parseInt(pageNumber, 10)
    const parsedPageSize = pageSize && parseInt(pageSize, 10)
    const parsedStartIndex = startIndex && parseInt(startIndex, 10)

    const wpsClient = new WPSClient(api)
    const response = await wpsClient.Storefront({
      context: context,
      ...(contentType && {contentType: contentType}),
      ...(contentId && {contentID: contentId}),
      ...(parsedPageNumber && {pageNumber: parsedPageNumber}),
      ...(parsedPageSize && {pageSize: parsedPageSize}),
      ...(filters && {filters: filters}),
      ...(serviceToken && {serviceToken: serviceToken}),
      ...(node && {nodeID: `${node}`}),
      ...(parsedStartIndex && {startIndex: parsedStartIndex}),
      ...(isElcano && {isElcano: safeBool(isElcano)}),
      ...(clientFilter && {clientFilter: clientFilter}),
      ...(targetId && {targetId: targetId})
    });
    
    // safeBool featureSwitches as its a <member name="featureSwitches" target="BooleanMap"/>
    response.featureSwitches = response.featureSwitches && Object.keys(response.featureSwitches)
        .reduce((acc: { [index: string]: any }, feature: string) => {
          acc[feature] = safeBool(response.featureSwitches[feature])
          return acc
    }, {}) as FeatureSwitches
      
    return response;
  } : undefined;

export const Storefront: Widget<StorefrontOutput> = {
  name: 'storefront',
  getProps,
  Component: withArgs(StorefrontComponent) as React.ComponentType<StorefrontOutput>
}